import { render, staticRenderFns } from "./ParentCourseSelectBox.vue?vue&type=template&id=6586f897"
import script from "./ParentCourseSelectBox.vue?vue&type=script&lang=js"
export * from "./ParentCourseSelectBox.vue?vue&type=script&lang=js"
import style0 from "./ParentCourseSelectBox.vue?vue&type=style&index=0&id=6586f897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports